export default __webpack_public_path__ + "assets/Ally-26ffa15b920d97bb36cee66d85ba30ac.svg";